module.exports = __webpack_public_path__ + "img/icon-warning-styrtregn-4.90823918.svg";